'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = 'M256 0c36.4 0 68.3 19.3 86.1 48.2 33-7.9 69.2 1.1 94.9 26.8s34.7 62 26.8 94.9C492.7 187.7 512 219.6 512 256s-19.3 68.3-48.2 86.1c7.9 33-1.1 69.2-26.8 94.9s-62 34.7-94.9 26.8C324.3 492.7 292.4 512 256 512s-68.3-19.3-86.1-48.2c-33 7.9-69.2-1.1-94.9-26.8s-34.7-62-26.8-94.9C19.3 324.3 0 292.4 0 256s19.3-68.3 48.2-86.1c-7.9-33 1.1-69.2 26.8-94.9s62-34.7 94.9-26.8C187.7 19.3 219.6 0 256 0zm0 16c-32.6 0-60.9 18.3-75.2 45.2l-3.1 5.8-6.3-1.9c-29.1-8.9-62.1-1.9-85.2 21.1s-30.1 56-21.1 85.2l1.9 6.3-5.8 3.1C34.3 195.1 16 223.4 16 256s18.3 60.9 45.2 75.2l5.8 3.1-1.9 6.3c-8.9 29.1-1.9 62.1 21.1 85.2s56 30.1 85.2 21.1l6.3-1.9 3.1 5.8C195.1 477.7 223.4 496 256 496s60.9-18.3 75.2-45.3l3.1-5.8 6.3 1.9c29.1 8.9 62.1 1.9 85.2-21.1s30.1-56 21.1-85.2l-1.9-6.3 5.8-3.1C477.7 316.9 496 288.6 496 256s-18.3-60.9-45.3-75.2l-5.8-3.1 1.9-6.3c8.9-29.1 1.9-62.1-21.1-85.2s-56-30.1-85.2-21.1l-6.3 1.9-3.1-5.8C316.9 34.3 288.6 16 256 16zm99.3 150.7l-4.7 6.5-113.7 156.4-5.6 7.7-6.6-6.8-62.3-64.5-5.6-5.8 11.5-11.1 5.6 5.8 55.7 57.6 108.1-148.7 4.7-6.5 12.9 9.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;